import { createSlice } from '@reduxjs/toolkit'

const brandSlice = createSlice({
  name: 'brand',
  initialState: [],
  reducers: {
    upsert: (s, a) => ({ ...s, ...a.payload }),
    set: (s, a) => a.payload,
    updateBrandTextContent: (state, action) => {
      const { language, key, value } = action.payload
      state.textContent ||= {}
      state.textContent[language] ||= {}
      state.textContent[language][key] = value
    },
  },
}).reducer

const local = createSlice({
  name: 'local',
  initialState: {
    error: null,
    loaded: false,
    dirty: false,
    validationErrors: {},
    language: 'en',
  },
  reducers: {
    upsert: (s, a) => ({ ...s, ...a.payload }),
  },
}).reducer

const reducers = {
  local,
  brand: brandSlice
}

export default reducers
